<template>
  <div class="feed-item">
    <div class="body-wrapper">
      <div class="feed-content">
        <FeedHeader :feed="feed" :feedType="feedType" />
        <div class="link-wrapper">
          <a href="javascript:;" @click="viewDetail">查看详情</a>
        </div>
        <div class="audio-cover-wrap flex">
          <div class="audio-icon-wrap">
            <img src="../../../assets/image/cl_music_icon.png" />
          </div>
          <div class="audio-info-wrap flex">
            <div class="audio-info">{{ initAudioInfo }}</div>
            <div class="audio-image-wrap">
              <img
                @click="viewDetail"
                src="../../../assets/image/cl_audio_img.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper">
      <FeedFooter :feed="feed" :feedType="feedType" />
    </div>
    <div>
      <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        custom-class="handlian-loading-detail"
        width="540px"
      >
        <div
          class="loading-feed-detail"
          v-loading="loading"
          element-loading-text="加载详情中"
          element-loading-spinner="el-icon-loading"
        ></div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { sliceFeedContent } from "../../../utils/feed";
import FeedHeader from "./feed-header";
import FeedFooter from "./feed-footer";
import { apiMap } from "../../../utils/apiMap";
export default {
  name: "audio-item",
  props: {
    feed: {
      type: Object,
      required: true,
    },
    page: Number,
  },
  data() {
    return {
      feedType: "3",
      loading: true,
      dialogVisible: false,
    };
  },
  components: {
    FeedHeader,
    FeedFooter,
  },
  computed: {
    initAudioInfo() {
      return `${this.feed.title}`;
    },
  },
  methods: {
    viewDetail() {
      console.log(this.feed);
      const initUserSign = {
        feedPage: 1,
        articlePage: 1,
        albumPage: 1,
        audioPage: this.page,
        videoPage: 1,
      };
      Store.dispatch("setUserCenterSign", initUserSign);
      // this.$router.push({
      //   path: "detail",
      //   query: { feedID: this.feed.id, feedType: this.feedType },
      // });
      let routerClanCard = this.$router.resolve({
        path: "detail",
        query: { feedID: this.feed.id, feedType: this.feedType },
      });
      window.open(routerClanCard.href, "_blank");
    },
  },
};
</script>
<style scoped>
.feed-item {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #fff;
}

.feed-summary {
  line-height: 25px;
  white-space: pre-wrap;
}

.link-wrapper a {
  color: #1a70db;
}

.loading-feed-detail {
  height: 100px;
}

.audio-cover-wrap {
  margin: 8px 0;
}

.audio-info-wrap {
  margin-left: 10px;
  flex-direction: column;
}

.audio-info {
  margin-bottom: 2px;
  font-size: 16px;
  line-height: 20px;
}

.audio-image-wrap {
  height: 34px;
}

.audio-image-wrap img {
  height: 100%;
  border-radius: 5px;
}
</style>